import React, { createContext, useState, useEffect } from 'react';

export const CityContext = createContext();

export const CityProvider = ({ children }) => {
  const [city, setCity] = useState('');

  useEffect(() => {
    const storedCity = localStorage.getItem('userAddress');
    if (storedCity) {
      setCity(storedCity);
    }
  }, []);

  const updateCity = (newCity) => {
    setCity(newCity);
    localStorage.setItem('userAddress', newCity);
  };

  return (
    <CityContext.Provider value={{ city, setCity: updateCity }}>
      {children}
    </CityContext.Provider>
  );
};
